import { GuiDetailAktionMobil } from "./GuiDetailAktionMobil";

export class GuiDetailAktionMobilCreate extends GuiDetailAktionMobil {
}
